import { ref } from "@vue/composition-api";

export const UserWords = {
  tab1: "Mapping",
  tab2: "Forensics",
};

export const BizWords = {
  tab1: "Investigation",
  tab2: "Risk",
};

const x_words = ref({});

const init_x_words = () => {
  const words_str = localStorage.getItem("x_words");
  if (words_str) {
    try {
      x_words.value = JSON.parse(words_str);
    } catch (e) {
      console.log("init_x_words err :", e);
    }
  } else {
    localStorage.setItem("x_words", JSON.stringify(UserWords));
    x_words.value = UserWords;
  }
};

init_x_words();

export const BackDoor = {
  x_words,
  set_x_words_to: (type: "user" | "biz") => {
    const words = type === "biz" ? BizWords : UserWords;
    x_words.value = words;
    localStorage.setItem("x_words", JSON.stringify(words));
  },
};
